import apiGroupsTrainers from '@/api/groups-trainers'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getAllGroupsTrainersStart:
    '[groups trainers all] Get all groups trainers start',
  getAllGroupsTrainersSuccess:
    '[groups trainers all] Get all groups trainers success',
  getAllGroupsTrainersFailure:
    '[groups trainers all] Get all groups trainers failure'
}

export const actionTypes = {
  getAllGroupsTrainers: '[groups trainers all] Get all groups trainers'
}

const mutations = {
  [mutationTypes.getAllGroupsTrainersStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getAllGroupsTrainersSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getAllGroupsTrainersFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.getAllGroupsTrainers](context) {
    context.commit(mutationTypes.getAllGroupsTrainersStart)
    return new Promise(resolve => {
      apiGroupsTrainers
        .getAllGroupsTrainers()
        .then(response => {
          context.commit(
            mutationTypes.getAllGroupsTrainersSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getAllGroupsTrainersFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
